import { ColumnDef } from '@/shared/store/models/store.models';
import { UsuarioList } from '../models';

// --- TOOLBAR_SCHEMA ---
// (No toolbar filters for this module)

// --- COLUMNS ---
export const USUARIOS_COLUMNS: ColumnDef<UsuarioList>[] = [
  { key: 'username', labelKey: 'Usuario', width: '150px' },
  { key: 'nombreCompleto', labelKey: 'Nombre', width: '250px' },
  { key: 'email', labelKey: 'Email', width: '200px' },
  {
    key: 'roles', labelKey: 'Roles', width: '200px',
    cell: r => r.roleNames?.join(', ') || '-'
  },
  {
    key: 'activo', labelKey: 'Activo', width: '100px',
    type: 'boolean', cell: r => r.activo ? 'Activo' : 'Inactivo'
  },
];
